<template>
    <div>      
        <multiselect
            :id="uniqueId"
            v-model="selectedDatapoints"
            :options="filteredData"
            :multiple="true"
            :searchable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :placeholder="placeholder"
            :label="label"
            :track-by="trackBy"
            @search-change="performSearch"
        >
            <template v-slot:tag="{ option, remove }">
                <span class="custom__tag">
                    {{ option[label] }}
                    <span class="custom__remove" @click="remove(option)"><i class="fas fa-times"></i></span>
                </span>
            </template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'SearchTool',
    components: { Multiselect },
    props: {
        placeholder: {
            type: String
        },
        data: {
            type: Array,
            default: () => []
        },
        label: {
            type: String
        },
        trackBy: {
            type: String
        }
    },
    emits: ['select'],
    watch: {
        selectedDatapoints(newVal) {
            this.$emit('select', newVal);
        }
    },
    data() {
        return {
            selectedDatapoints: [],
            searchQuery: '',
            uniqueId: ''
        }
    },
    created() {
        this.uniqueId = `${this.label}-${Math.floor(Math.random() * 1000000)}`;
    },
    computed: {
        filteredData() {
            return this.data.filter(datapoint => 
                datapoint[this.label].toLowerCase().includes(this.searchQuery.toLowerCase())
            )
        }
    },
    methods: {
        performSearch(query) {
            this.searchQuery = query
        }
    }
}
</script>

<style scoped>
.custom__tag {
    display: inline-block;
    background: #e4e4e4;
    padding: 5px;
    margin: 2px;
    border-radius: 3px;
}

.custom__remove {
    cursor: pointer;
    margin-left: 5px;
}
</style>